import React from 'react'
import ModalEliminar from './SEModalEliminar'
import ModalEditarProducto from './SEModalEditarProducto'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../../../reducers'
import {
  sujetoExcluidoArrayProductoClearAll,
  sujetoExcluidoArrayProductoDeleteOne,
  sujetoExcluidoModalsClose,
} from '../../../../../actions/sujeto-excluido/sujetoExcluidoProductos.actions'
import {generalOpenModalInfo} from '../../../../../actions/general.actions'

const SEModalsGeneracion = () => {
  const {activeEliminarUno, activeQuitarTodo, activeEditar} = useSelector(
    (state: State) => state.sujetoExcluido.modals
  )
  const dispatch = useDispatch()

  const closeModalEliminar = () => dispatch(sujetoExcluidoModalsClose())

  const actionEliminar = () => {
    if (activeEliminarUno) {
      dispatch(sujetoExcluidoArrayProductoDeleteOne())
      dispatch(generalOpenModalInfo('El producto fue eliminado satisfactoriamente.'))
    } else {
      dispatch(sujetoExcluidoArrayProductoClearAll())
      dispatch(generalOpenModalInfo('Todos los productos han sido eliminados satisfactoriamente.'))
    }

    closeModalEliminar()
  }
  return (
    <>
      {(activeEliminarUno || activeQuitarTodo) && (
        <ModalEliminar
          eliminar={activeEliminarUno ? true : false}
          closeModalEliminar={closeModalEliminar}
          actionEliminar={actionEliminar}
        />
      )}
      {activeEditar && <ModalEditarProducto />}
    </>
  )
}

export default SEModalsGeneracion
